import Button from "../UI/Button";
import Modal, { ModalProps } from "./index";
import { MainContainer, Header, ModalFooter } from "./ModalStyledComponents";

interface Props extends ModalProps {
    onConfirm: () => void;
    onCancel: () => void;
    title: string;
    confirmLabel: string;
    cancelLabel: string;
}

const ConfirmationModal = ({
    onClose,
    open,
    children,
    title,
    confirmLabel,
    cancelLabel,
    onCancel,
    onConfirm,
}: Props) => (
    <Modal onClose={onClose} open={open} hideClose>
        <MainContainer style={{ minWidth: "500px" }}>
            <Header>{title}</Header>
            <div>{children}</div>
            <ModalFooter>
                <Button
                    style={{ width: "120px" }}
                    onClick={onCancel}
                    className="btn btn-primary"
                >
                    {cancelLabel}
                </Button>
                <Button
                    style={{ width: "120px" }}
                    onClick={onConfirm}
                    className="btn btn-danger"
                >
                    {confirmLabel}
                </Button>
            </ModalFooter>
        </MainContainer>
    </Modal>
);

export default ConfirmationModal;
